import { TriviaList } from '@repo/types'
import { Spinner } from '@repo/ui'
import { runInAction } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { apiClient } from '@/api/api-client'
import { useDialogContext } from '@/dialogs/DialogContext'
import { MixpanelService } from '@/mixpanel'
import { useQueryUserTriviaLists } from '@/pages/trivia-lists/queries/useQueryUserTriviaLists'
import StoreService from '@/store/StoreService'

import { ManageTriviaLists } from './manage-trivia-lists'
import { validateTriviaList } from '../edit-trivia-list/utils/validate-list'
import { useDeleteUserTriviaList } from '../queries/useDeleteUserTriviaList'

const PAGE_TITLE = 'Manage Trivia Lists'

export const ManageTriviaListsUser = observer(() => {
  const { data: triviaLists = [], isLoading } = useQueryUserTriviaLists()
  const { mutate: deleteUserTriviaList } = useDeleteUserTriviaList()
  const store = StoreService.getStore()

  const [isStartingGame, setIsStartingGame] = useState<string | undefined>()
  const history = useHistory()

  const handleClick = async (triviaList: TriviaList) => {
    setIsStartingGame(triviaList.id)

    runInAction(() => {
      store.isLoadingGame = true
    })

    const { gameId } = await apiClient.createGame({ triviaList, type: 'trivia' })

    history.push('/game/setup/gameplay')

    setIsStartingGame(undefined)

    MixpanelService.createGameTrivia(gameId, {
      triviaList,
      type: 'trivia'
    })
  }

  const { setConfirmPrompt } = useDialogContext()

  const handleClickDelete = (listId: string) => {
    setConfirmPrompt({
      description: 'This action cannot be undone',
      heading: 'Are you sure you want to delete this trivia list?',
      onConfirm: () => deleteUserTriviaList(listId)
    })
  }

  if (isLoading) return <Spinner label='Loading...' />

  const validatedTriviaLists = triviaLists.map(validateTriviaList)

  return (
    <ManageTriviaLists
      isLoading={isLoading}
      isStartingGame={isStartingGame}
      pageTitle={PAGE_TITLE}
      triviaLists={validatedTriviaLists}
      onDeleteTriviaList={handleClickDelete}
      onStartGame={handleClick}
    />
  )
})
